import { BrowseListService } from './../../services/browse-list.service';
import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as _ from 'lodash';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/take';

@Component({
  selector: 'app-browse',
  templateUrl: './browse.component.html',
  styleUrls: ['./browse.component.css']
})
export class BrowseComponent implements OnInit {

  fokos = new BehaviorSubject([]);
  batch = 12;
  lastKey = '';
  finished = false;

  constructor(public browseListService: BrowseListService) {
    console.log('browse component is instantiated');
  }

  ngOnInit() {
    this.getFokos();
  }

  onScroll() {
    console.log('scrolled');
    this.getFokos();
  }

  private getFokos(key?) {
    console.log(this.lastKey);
    if (this.finished) { alert('end of database'); return; }
    this.browseListService.getFokos(this.batch + 1, this.lastKey).snapshotChanges()
      .do(fokos => {
        /// set the lastKey in preparation for next query
        this.lastKey = _.last(fokos)['key'];
        console.log(fokos);

        const newFokos = _.slice(fokos, 0, this.batch);

        /// Get current movies in BehaviorSubject
        const currentMovies = this.fokos.getValue();

        /// If data is identical, stop making queries
        if (this.lastKey === _.last(newFokos)['key']) {
          this.finished = true;
        }

        /// Concatenate new movies to current movies
        this.fokos.next( _.concat(currentMovies, newFokos) );
      })
      .take(1)
      .subscribe();
  }

}



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/ui/browse/browse.component.ts